// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import Link from "metabase/common/components/Link";
import { alpha, color, darken } from "metabase/lib/colors";
import {
  breakpointMaxLarge,
  breakpointMaxMedium,
} from "metabase/styled-components/theme";

import { ADMIN_NAVBAR_HEIGHT } from "../../constants";

export const AdminNavbarRoot = styled.nav`
  margin: 1rem 2rem;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.15);
  box-shadow: 0 6px 18px rgba(0,0,0,0.15);
  background: ${() => color("admin-navbar")};
  color: var(--mb-color-text-white);
  font-size: 1.2rem;
  height: ${ADMIN_NAVBAR_HEIGHT};
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 4;
  flex-shrink: 0;
`;

export const AdminNavbarItems = styled.ul`
  display: flex;
  flex-grow: 0;
  min-width: 0;
  gap: 1rem;
`;

export const MobileHide = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  flex-grow: 1;
  padding-inline-start: 2rem;
  ${breakpointMaxMedium} {
    display: none;
  }
`;

export const AdminMobileNavbar = styled.div`
  ${breakpointMaxMedium} {
    display: block;
  }

  display: none;
`;

export const AdminMobileNavBarItems = styled.ul`
  display: flex;
  position: absolute;
  flex-direction: column;
  text-align: center;
  padding: 0.5rem 1rem;
  opacity: 0.9;
  gap: 0.5rem;
  border-radius: 2rem;
  // top: ${ADMIN_NAVBAR_HEIGHT};
  right: 2rem;
  background: ${() => color("admin-navbar")};
  max-height: calc(100vh - ${ADMIN_NAVBAR_HEIGHT});
  overflow-y: auto;
`;

export const AdminExitLink = styled(Link)`
  border-radius: 999px;
  border: 1px solid ${() => alpha("bg-white", 0.2)};
  padding: 1rem 1.25rem;
  font-weight: 700;
  font-size: 1rem;
  transition: all 200ms;
  color: ${() => color("admin-navbar")};
  white-space: nowrap;
  text-align: center;
  margin-inline-start: auto;
  background-color: white;

  ${breakpointMaxMedium} {
    margin: 0;
  }

  &:hover {
    color: var(--mb-color-text-white);
    background-color: ${() => color("admin-navbar")};
    border-color: ${() => darken(color("filter"))};
  }
`;

export const AdminLogoContainer = styled.div`
  display: flex;
  min-width: 32px;
  max-width: 20rem;
  overflow: hidden;
  height: 32px;
  align-items: center;
  justify-content: center;
`;

export const AdminLogoText = styled.div`
  margin-left: 1rem;
  font-weight: 700;

  ${breakpointMaxLarge} {
    display: none;
  }
`;

export const AdminLogoLink = styled(Link)`
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin-left: 1rem;
`;
